import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import { faBars } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Backdrop from "../backdrop/backdrop";
// import { useState } from "react";
import Sidebar from "./Sidebar";
// import logo from "./logo.jpg";

// import NavigationItems from "../NavigationItems/NavigationItems";

import "./navbar.css";

function Navbar(props) {
  const [state, setState] = useState(false);
  const toggle = () => {
    setState((prev) => !prev);
  };
  return (
    <nav className="main-nav">
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          backgroundColor: "black",
          width: "200px",
          height: "65px",
        }}
      >
        <img src="/images/logo.png" alt="ss" />
        <img src="/images/sologan.png" alt="ss" />
      </div>
      <div style={{ display: "flex", alignItems: "center" }}>
        {props.isAuth && (
          <button
            onClick={props.onLogout}
            style={{
              width: "100px",
              height: "47px",
              background: "#347b97",
              border: "1px solid",
              color: " #e0e0e0",
              fontSize: "23px",
            }}
          >
            logout
          </button>
        )}
        <FontAwesomeIcon
          icon={faBars}
          onClick={toggle}
          id="icon"
        ></FontAwesomeIcon>
      </div>
      {state && (
        <>
          <Backdrop onClick={toggle} />
          <Sidebar onClick={toggle} />
        </>
      )}
      {/* <Sidebar /> */}
    </nav>
  );
}

export default Navbar;
